export const DEFAULT_SORT_DIRECTION = 'asc';
